import React from "react";
import Slider from "react-slick";
import { CardsImgData } from "../common/Content";
import CardImg3 from "../../assets/img/cards/cardimg3.webp";
import { getValue } from "@testing-library/user-event/dist/utils";
import vision from "../../assets/img/cards/vision.webp";
import strategy from "../../assets/img/cards/strategy.webp";
import values from "../../assets/img/cards/values.webp";
import mission from "../../assets/img/cards/mission.webp";
const Cards = () => {
  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   arrows: false,
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 3,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //       },
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         initialSlide: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };

  return (
    <>
      {/* <div className="open_overlay_sections_none">
        <Slider {...settings}>
          {CardsImgData &&
            CardsImgData.map((items, index) => {
              return (
                <div className=" slider_hover_hidden">
                
                  <div className="slider_hover" key={index}>
                    <div className="position-relative">
                      <img className="w-100" src={items.img} alt="" />
                      <div className="position-absolute bottom-0 w-100 text-center pb-5">
                        <h1 className="font-xl text-white fw-semibold">
                          {items.heading}
                        </h1>
                        <p className="fw-normal fs-normal px-xl-5 mx-xl-3 text-white opacity_07">
                          {items.text}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Slider>


      </div> */}

      <section className="open_overlay_sections_none   pb-sm-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4 col-xxl-3 mb-4">
              <div className="card_box p-3 text-center">
                <img className="mb-2" src={vision} alt="" />
                <h2 className="font-xl fw-semibold black">VISION</h2>
                <p className="font-normal opacity_07  black">
                  Cum congue amet rhoncus vulputate tempor. Amet condimentum
                  nulla vitae odio aliquam amet, sagittis in. In id tristique
                  iaculis pharetra neque, morbi egestas. Eu tincidunt est metus
                  semper scelerisque adipiscing.
                </p>
                <div className="py-3 learn_btns">
                  <a
                    href=""
                    className="learn_btn  px-3 py-2 black text-decoration-none font-normal"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-3 mb-4">
              <div className="card_box p-3 text-center">
                <img className="mb-2" src={strategy} alt="" />
                <h2 className="font-xl fw-semibold black">STRATEGY</h2>
                <p className="font-normal opacity_07  black">
                  Cum congue amet rhoncus vulputate tempor. Amet condimentum
                  nulla vitae odio aliquam amet, sagittis in. In id tristique
                  iaculis pharetra neque, morbi egestas. Eu tincidunt est metus
                  semper scelerisque adipiscing.
                </p>
                <div className="py-3 learn_btns">
                  <a
                    href=""
                    className="learn_btn  px-3 py-2 black text-decoration-none font-normal"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-3 mb-4">
              <div className="card_box p-3 text-center">
                <img className="mb-2" src={values} alt="" />
                <h2 className="font-xl fw-semibold black">Value</h2>
                <p className="font-normal opacity_07  black">
                  Cum congue amet rhoncus vulputate tempor. Amet condimentum
                  nulla vitae odio aliquam amet, sagittis in. In id tristique
                  iaculis pharetra neque, morbi egestas. Eu tincidunt est metus
                  semper scelerisque adipiscing.
                </p>
                <div className="py-3 learn_btns">
                  <a
                    href=""
                    className="learn_btn  px-3 py-2 black text-decoration-none font-normal"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-3 mb-4">
              <div className="card_box p-3 text-center">
                <img className="mb-2" src={mission} alt="" />
                <h2 className="font-xl fw-semibold black">MISSION</h2>
                <p className="font-normal opacity_07  black">
                  Cum congue amet rhoncus vulputate tempor. Amet condimentum
                  nulla vitae odio aliquam amet, sagittis in. In id tristique
                  iaculis pharetra neque, morbi egestas. Eu tincidunt est metus
                  semper scelerisque adipiscing.
                </p>
                <div className="py-3 learn_btns">
                  <a
                    href=""
                    className="learn_btn  px-3 py-2 black text-decoration-none font-normal"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cards;
